const tshirtShorthandMap = {
  'extra-small': 'xs',
  small: 'sm',
  medium: 'md',
  large: 'lg',
  'extra-large': 'xl'
};
const tshirtLonghandMap = Object.fromEntries(Object.entries(tshirtShorthandMap).map(entry => entry.reverse()));

/**
 * @param {string} size
 * @returns {string} The shorthand size corresponding to the given longhand size, or `size` itself.
 */
export const toShorthandSize = size => tshirtShorthandMap[size] || size;

/**
 * @param {string} size
 * @returns {string} The longhand size corresponding to the given shorthand size, or `size` itself.
 */
export const toLonghandSize = size => tshirtLonghandMap[size] || size;